// client/src/pages/Kjopsvilkar.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Kjopsvilkar() {
  return (
    <div className="max-w-3xl mx-auto p-6">
      <div className="mb-4">
        <Link to="/" className="text-blue-600 hover:underline">← Til forsiden</Link>
      </div>

      <h1 className="text-3xl font-bold text-[#000099]">Kjøpsvilkår</h1>
      <p className="text-sm text-gray-600 mt-1">Sist oppdatert: 10.09.2025</p>

      <div className="bg-white rounded-xl shadow p-6 mt-6 space-y-5 text-gray-800">
        <p>
          Disse vilkårene gjelder for forbrukerkjøp av varer fra Ryfylke Utleie via vår nettside.
          Vilkårene begrenser ikke dine lovbestemte rettigheter etter blant annet forbrukerkjøpsloven,
          angrerettloven, ehandelsloven og markedsføringsloven.
        </p>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">1. Avtalen</h2>
          <p>
            Avtalen består av disse salgsbetingelsene, opplysninger gitt i bestillingsløsningen og eventuelt
            særskilt avtalte vilkår. Ved motstrid går særskilt avtalte vilkår foran så langt de ikke strider mot ufravikelig lov.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">2. Partene</h2>
          <p>
            <strong>Selger:</strong> Ryfylke Utleie, Industrivegen 14, 4120 Tau, e-post: <a className="text-blue-600 hover:underline" href="mailto:post@ryfylkeutleie.no">post@ryfylkeutleie.no</a>, telefon: 404 91 955, org.nr: 917 538 379.<br />
            <strong>Kjøper:</strong> Den forbruker som legger inn bestillingen.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">3. Pris</h2>
          <p>
            Alle priser er i NOK inkl. mva. Totalkostnaden (inkl. frakt/tilleggskostnader) vises før bestilling.
            Kostnader som ikke er opplyst før bestilling skal ikke belastes kjøper.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">4. Avtaleinngåelse</h2>
          <p>
            Avtalen er bindende når bestillingen er sendt. Avtalen er ikke bindende ved åpenbare skrive-/systemfeil
            som motparten innså eller burde innsett.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">5. Betaling</h2>
          <p>
            Betaling skjer med metodene som er tilgjengelige i kassen (f.eks. kort, Vipps, faktura).
            Ved kort/Vipps kan beløpet reserveres ved bestilling og trekkes ved sending/utlevering.
            Ved faktura utstedes denne ved sending/utlevering med minst 14 dagers forfall. Kjøpere under 18 år kan ikke betale med etterfølgende faktura.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">6. Levering / henting</h2>
          <p>
            Henting hos Ryfylke Utleie etter avtale.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">7. Risikoens overgang</h2>
          <p>
            Risikoen for varen går over på deg når du (eller noen på dine vegne) har fått varen i besittelse i tråd med punkt 6.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">8. Angrerett (14 dager)</h2>
          <p>
            Du kan angre kjøpet innen 14 dager fra dagen etter mottak. Meld fra innen fristen (gjerne skriftlig til
            <a className="text-blue-600 hover:underline" href="mailto:post@ryfylkeutleie.no"> post@ryfylkeutleie.no</a>), og returner varen senest 14 dager
            etter at du meldte angrerett. Du betaler returkostnaden med mindre annet er opplyst. Varen kan prøves som i butikk; bruk utover nødvendig prøving kan
            medføre verdireduksjon. Vi tilbakebetaler uten unødig opphold og senest 14 dager etter melding, men kan holde tilbake til varen er mottatt eller retur er dokumentert.
          </p>
          <p className="mt-2 text-sm text-gray-600">
            Unntak kan gjelde for bl.a. spesialtilvirkede varer, forseglede hygieneprodukter med brutt forsegling m.m.
            Angrerettskjema følger med ordrebekreftelsen eller fås ved forespørsel.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">9. Forsinkelse og manglende levering</h2>
          <p>
            Ved forsinkelse som ikke skyldes forhold på din side kan du etter loven holde betaling tilbake, kreve oppfyllelse,
            heving etter rimelig tilleggsfrist og/eller erstatning. Krav bør fremmes skriftlig.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">10. Mangel og reklamasjon</h2>
          <p>
            Reklamer innen rimelig tid etter at mangelen ble oppdaget; reklamasjon innen 2 mnd. anses alltid i tide.
            Fristen er 2 år (5 år for varer ment å vare vesentlig lenger). Du kan kreve retting/omlevering, prisavslag,
            heving og/eller erstatning etter forbrukerkjøpsloven. Vi kan foreta inntil to avhjelpsforsøk innen rimelig tid.
          </p>
          <p className="mt-2 text-sm text-gray-600">
            Reklamasjon sendes til <a className="text-blue-600 hover:underline" href="mailto:post@ryfylkeutleie.no">post@ryfylkeutleie.no</a> med ordrenummer og beskrivelse/bilder.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">11. Selgerens rettigheter ved mislighold</h2>
          <p>
            Ved manglende betaling kan vi holde varen tilbake, kreve oppfyllelse, heving ved vesentlig mislighold,
            og renter/inkassogebyr etter lov. Uavhentede ikke-forskuddsbetalte varer kan ilegges gebyr som dekker våre faktiske utlegg.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">12. Garanti</h2>
          <p>
            Eventuelle garantier kommer i tillegg til dine lovbestemte rettigheter. Garantivilkår fremgår av produktinformasjon/garantibevis.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">13. Personopplysninger</h2>
          <p>
            Vi behandler kun nødvendige personopplysninger for å gjennomføre avtalen og som beskrevet i vår personvernerklæring.
            Opplysninger utleveres kun når det er nødvendig for å oppfylle avtalen eller når lov krever det.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-[#000099]">14. Konfliktløsning</h2>
          <p>
            Klager rettes til oss innen rimelig tid. Vi søker minnelige løsninger. Ved uenighet kan Forbrukertilsynet kontaktes for mekling
            (tlf. 23 400 600, forbrukertilsynet.no). EU-kommisjonens klageportal (ec.europa.eu/odr) kan benyttes ved grensekryssende tvister.
          </p>
        </section>
      </div>
    </div>
  );
}
